import { MagentoBookstoreAddress } from "../checkout/shop-checkout.interface";

export const mapInstructorShippingEstimationResponse = (shippingResponse) => {
  return shippingResponse.filter(shipping => !!shipping.method_code)
    .map(shipping => ({
      carrier_code: shipping.carrier_code,
      method_code: shipping.method_code,
      carrier_title: shipping.carrier_title,
      method_title: shipping.method_title,
      available: shipping.available,
      error_message: shipping.error_message,
    })
  );
}

export const mapInstructorShippingAndBillingAddressPayload = (bookstoreAddress: MagentoBookstoreAddress) => {
  return {
    region_code: bookstoreAddress.region_code,
    country_id: bookstoreAddress.country_id,
    street: bookstoreAddress.street,
    postcode: bookstoreAddress.postcode,
    city: bookstoreAddress.city,
    firstname: bookstoreAddress.firstname,
    lastname: bookstoreAddress.lastname,
    email: bookstoreAddress.email,
    telephone: bookstoreAddress.telephone,
  } as MagentoBookstoreAddress;
}